export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";